export default __webpack_public_path__ + "static/media/monaco-team-offer-discount-20-milita-top.4c026677.png";